import { useEffect, useState } from "react";
import { useTypedDispatch, useTypedSelector } from "../../../../redux/hooks";
import { AnimatedDiv } from "../../../../animation";
import Reply from "../../Reply";
import { ConversationMessageProvider } from "../../../../context/MessageContext/context";
import styles from "./ReplyTo.module.scss";
import Icon from "../../../../components/Icon";
import AriaButton from "../../../../components/AriaComponents/AriaButton";
import { useConversationContext } from "../../../../context/ChatContext/contextConvo";
import { clearActiveMessageReply } from "../../../../redux/slices";

interface Props {
    focusOnEditor: () => void;
}

const ReplyTo: React.FC<Props> = ({ focusOnEditor }) => {
    const { conversation } = useConversationContext();
    const [showPreview, setShowPreview] = useState(false);

    const dispatch = useTypedDispatch();

    const handleDelete = () => {
        dispatch(clearActiveMessageReply(conversation.uuid));
    }

    const messageReply = useTypedSelector(state => state.chat.messageReplies[conversation.uuid]);

    useEffect(() => {
        focusOnEditor()
    }, [messageReply?.message.uuid]);

    return (
        <AnimatedDiv visible={!!messageReply} className={styles.reply_to_container}
            onMouseOver={() => setShowPreview(true)}
            onMouseOut={() => setShowPreview(false)}
        >
            <ConversationMessageProvider message={messageReply?.message}>
                <Reply input />
            </ConversationMessageProvider>
            <div className={styles.primary_action_container} data-is-download={!handleDelete}>
                <AnimatedDiv visible={showPreview}>
                    <AriaButton
                        onClick={() => handleDelete()}
                    >
                        <Icon name='cross' />
                    </AriaButton>
                </AnimatedDiv>
            </div>
        </AnimatedDiv>
    )
}

export default ReplyTo;
